/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody, Button,
} from 'reactstrap';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import BaseGrid from '../../components/Common/BaseGrid';
import { Can } from '../../utilities/Can';
import { post, get } from '../../helpers/api_helper';
// import * as url from '../../helpers/url_helper';

function Slack(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const [, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const updateUsers = async () => {
    setLoading(true);

    try {
      const users = await get('/api/user?per=1000');

      for (let i = 0; i < users.results.length; i += 1) {
        post(`/api/slack/user/${users.results[i].id}`, '[]');
      }
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  const sendTestMessage = async () => {
    try {
      await get('/api/slack/message');
    } catch (e) {
      setError(e.message);
    }
  };

  const sendChannelMessage = async (channel, msg) => {
    try {
      await post(`/api/slack/message/channel/${channel}`, { msg });
    } catch (e) {
      setError(e.message);
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xl="4">
            <Card>
              <CardBody className="text-center">
                <Can i="see" this="slack">
                  <div className="hstack gap-2 mb-3">
                    <Button color="secondary" size="sm" onClick={sendTestMessage}>
                      <span className="mdi mdi-mail" />
                      {' '}
                      Send Me a Test Message
                    </Button>

                    <Button
                      color="secondary"
                      size="sm"
                      onClick={() => {
                        sendChannelMessage('shipping', 'ping');
                      }}
                    >
                      <span className="mdi mdi-mail" />
                      {' '}
                      Send channel message
                    </Button>
                  </div>

                  <div>
                    <a
                      href="#"
                      style={{
                        alignItems: 'center',
                        color: '#fff',
                        backgroundColor: '#4A154B',
                        border: 0,
                        borderRadius: '4px',
                        display: 'inline-flex',
                        fontFamily: 'Lato, sans-serif',
                        fontSize: '18px',
                        fontWeight: 600,
                        height: '56px',
                        justifyContent: 'center',
                        textDecoration: 'none',
                        width: '276px',
                      }}
                      onClick={updateUsers}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ height: '24px', width: '24px', marginRight: '12px' }}
                        viewBox="0 0 122.8 122.8"
                      >
                        <path d="M25.8 77.6c0 7.1-5.8 12.9-12.9 12.9S0 84.7 0 77.6s5.8-12.9 12.9-12.9h12.9v12.9zm6.5 0c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9v32.3c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V77.6z" fill="#e01e5a" />
                        <path d="M45.2 25.8c-7.1 0-12.9-5.8-12.9-12.9S38.1 0 45.2 0s12.9 5.8 12.9 12.9v12.9H45.2zm0 6.5c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H12.9C5.8 58.1 0 52.3 0 45.2s5.8-12.9 12.9-12.9h32.3z" fill="#36c5f0" />
                        <path d="M97 45.2c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9-5.8 12.9-12.9 12.9H97V45.2zm-6.5 0c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V12.9C64.7 5.8 70.5 0 77.6 0s12.9 5.8 12.9 12.9v32.3z" fill="#2eb67d" />
                        <path d="M77.6 97c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9-12.9-5.8-12.9-12.9V97h12.9zm0-6.5c-7.1 0-12.9-5.8-12.9-12.9s5.8-12.9 12.9-12.9h32.3c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H77.6z" fill="#ecb22e" />
                      </svg>
                      {loading && (
                        <span>{props.t('Updating...')}</span>
                      )}
                      {!loading && (
                        <span>{props.t('Update Users')}</span>
                      )}
                    </a>
                  </div>
                </Can>

                <Can not i="see" this="slack"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>
          </Col>
          <Col xl="4">
            <Card>
              <CardBody>
                <BaseGrid
                  url="/api/slack/apps"
                  shouldPaginate={false}
                  config={
                    {
                      columns: {
                        app_id: { label: 'App ID', sort: true },
                        client_id: { label: 'Client ID', sort: true },
                      },
                      pagination: {
                        sort: 'id',
                        direction: 'desc',
                        perPage: 30,
                      },
                    }
                  }
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}

Slack.defaultProps = {
  t: (x) => (x),
};

Slack.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(Slack));
